import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { downgradeComponent } from '@angular/upgrade/static';
import { PermissionsModule } from '@core/directives/permissions/permissions/permissions.module';
import { OrderDeliveryViewComponent } from './components/order-delivery-view/order-delivery-view.component';
import { ShipmentBoxComponent } from './components/shipment-box/shipment-box.component';
import { PlannerManagerService } from './services/planner-manager.service';
import { PlanerRangeSelectionComponent } from '../_components/planer-range-selection/planer-range-selection.component';
import { PlannerDraggingManagerService } from '../delivery-order-planner/services/planner-draggin-manager.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  declarations: [OrderDeliveryViewComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,

    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    MatTooltipModule,
    FormsModule,
    ShipmentBoxComponent,
    PermissionsModule,
    PlanerRangeSelectionComponent,
  ],
  providers: [PlannerManagerService, PlannerDraggingManagerService]
})
export class OrderDeliveryModule { }



export function bindOrderDeliveryViewToAngularJS(angular: any) {
  angular.directive('orderDeliveryComponent', downgradeComponent({ component: OrderDeliveryViewComponent }));
}
